import React, { Component } from 'react';
export default class NoPermission extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        return <div style={{
            textAlign: "center",
            padding: "2px"
        }}>没有权限</div>;
    }
}